import {Modal} from '@baidu/luffy-comp-modal';
export default Modal;
